<template>
    <div>
        <template v-if="!isLocationEnabled">
            <onLocationOff></onLocationOff>
        </template>
        <template v-else-if="!isAvailable">
            <OnUnvailable></OnUnvailable>
        </template>
        <template v-else>
            <template v-if="!trip && !offeredTrips.length">
                <OnReadyForService></OnReadyForService>
            </template>
            <template v-else>
                <template v-if="trip">
                    <OnPickingUpTrip v-if="trip.frontState == TRIP_STATE.ACCEPTED || trip.frontState == TRIP_STATE.ARRIVED_TO_ORIGIN"></OnPickingUpTrip>
                    <OnFinishingTrip v-if="trip.frontState == TRIP_STATE.RIDEUP || trip.frontState == TRIP_STATE.ARRIVED_TO_DESTINATION"></OnFinishingTrip>
                </template>
                <template v-else>
                    <TripsOffered></TripsOffered>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OnPickingUpTrip from '../elements/driver/OnPickingUpTrip.vue';
import OnFinishingTrip from '../elements/driver/OnFinishingTrip.vue';
import TripsOffered from '../elements/driver/TripsOffered.vue';
import OnReadyForService from '../elements/driver/OnReadyForService.vue';
import OnUnvailable from '../elements/driver/OnUnvailable.vue';
import bus from '@/services/bus-event';

export default {
    name: 'driverTrip',
    props: [

    ],
    data () {
        return {

        };
    },

    computed: {
        ...mapGetters({
            logged: 'auth/checkLogin',
            user: 'auth/user',
            isMobile: 'device/isMobile',
            isAvailable: 'driver/isAvailable',
            trip: 'driver/actualTrip',
            offeredTrips: 'driver/offeredTrips',
            isLocationEnabled: 'geolocation/locationEnabled'
        })
    },

    mounted () {
        this.language = this.$getLang();
        // cordova_resume
        bus.on('cordova_resume', this.onCordovaResume);
    },
    updated () {
    },
    methods: {
        ...mapActions({
            callToLocationSettings: 'geolocation/callToLocationSettings',
            checkState: 'driver/checkState'
        }),
        onActivateLocation () {
            this.callToLocationSettings();
        },
        onCordovaResume () {
            console.log('onCordovaResumen in Driver');
            this.checkState();
        }
    },
    beforeDestroy () {
        bus.off('cordova_resume', this.onCordovaResume);
    },
    components: {
        OnPickingUpTrip,
        OnFinishingTrip,
        TripsOffered,
        OnReadyForService,
        OnUnvailable
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sections/DriverTrip.vue